// Thin wrapper over PowerSync's global first-sync signal.
//
// App-level components must not import `@powersync/react` directly (architecture
// Rule 4 — PowerSync access goes through hooks/). This exposes the one bit
// AutoReinjectStashedWork needs: whether the FIRST full sync has completed. Once
// `hasSynced` is true, every subscribed stream (including `captures`) has downloaded
// at least once, so an already-synced capture_items row is present locally — the
// precondition for the offline-logout stash's edit re-apply to collide with that row
// and re-apply as a PATCH rather than emit a create-PUT the backend idempotent-drops
// (see auto-reinject-stashed-work.tsx + requeue-stashed-counts.ts :155).

import { useStatus } from '@powersync/react'

/** True once PowerSync has completed its first full sync this session. `hasSynced`
 *  is `boolean | undefined` (undefined before the status is first reported); coerce
 *  undefined to false so the re-inject HOLDS until sync is positively confirmed. */
export function useHasSynced(): boolean {
  return useStatus().hasSynced === true
}
